<template>
    <b-autocomplete
      rounded
      field="name"
      v-model="searchTerm"
      v-bind:data="metrics"
      placeholder="Search for a metric"
      icon="search"
      icon-pack="fas"
      clearable
      open-on-focus
      v-on:select="option => (selectMetric(option))"
      @input="loadResults"
      check-infinite-scroll
    >
      <template slot-scope="props">
        <div class="media">
          <div class="media-left">
            <b-icon pack="fas" :icon="props.option.subcategory[0].icon"/>
          </div>
          <div class="media-content">
            <small>{{ props.option.name }}</small>
          </div>
      </div>
    </template>
    <template slot="empty">No results found</template>
  </b-autocomplete>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      searchTerm: '',
      metrics: [],
      abortControllers: [],
    };
  },
  components: {},
  props: {
    callback: Function,
    originalMetric: Object,
  },
  computed: {
  },
  methods: {
    selectMetric: function(option) {
      this.callback.call(this, option);
    },
    async loadResults() {
      this.abortControllers.forEach(controller => controller.abort());
      const abortController = new AbortController();
      this.abortControllers.push(abortController);
      this.loading = true;
      try {
        const data = await fetch(`/api/v1/impact_factors/?search=${this.searchTerm}`, { signal: abortController.signal });
        const jsonData = await data.json();
        this.metrics = jsonData.metrics;
      } catch (e) {
        if (e.name === 'AbortError') {
          console.log('aborted');
        } else {
          console.log(e);
        }
      }
      this.loading = false;
    },
  },
  watch: {
    originalMetric() {
      if (this.originalMetric.name) {
        this.selectMetric(this.originalMetric);
        this.searchTerm = this.originalMetric.name;
      }
    }
  },
  mounted() {
    this.loadResults();
  },
};
</script>
